import type { PartnerComponents } from 'config/types';
import { lazyWithPreload } from 'utils/bundle';
import { getPartnerSpecificComponent } from 'utils/helpers';

const DefaultComponent = lazyWithPreload(() => import('packages/app/home'));
const InstaShopCheckOut = lazyWithPreload(() => import('packages/instashop/home'));
const CareemComponent = lazyWithPreload(() => import('packages/careem/home'));

const components: PartnerComponents<{}> = {
  CAREEM: CareemComponent,
  INSTASHOP: InstaShopCheckOut,
  Default: DefaultComponent,
};

export const HomePage = getPartnerSpecificComponent<{}>(components);
